<template>
    <n-dialog v-model:visible="visible" :z-index="4100">
        <div class="logout-content" :class="{'desktop-logout-content': isDesktop}">
            <div class="logout-content-title">
                {{ $t('accountLoginOutTip1') }}
            </div>
            <div class="logout-content-sub_title">
                {{ $t('accountLoginOutTip2') }}
            </div>
            <div class="logout-content-button">
                <div class="logout-content-button-item_cancel" @click="handleCancel">
                    <div class="logout-content-button-item_cancel_text">
                        {{ $t('accountLoginOutBtn1') }}
                    </div>
                </div>
                <div class="logout-content-button-item_confirm" @click="handleLogout">
                    <div class="logout-content-button-item_confirm_text">
                        {{ $t('accountLoginOutBtn2') }}
                    </div>
                </div>
            </div>
        </div>
    </n-dialog>
</template>

<script setup lang="ts">
import useUserStore from '~/store/modules/user'
const userStore = useUserStore()
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const visible = ref(false)
let confirmHandler: (() => void) | undefined
const handleLogout = ()=>{
    console.log('退出登录')
    visible.value = false
    const onConfirmed = confirmHandler
    confirmHandler = undefined
    onConfirmed?.()
    userStore.logout(()=>{
        window.location.href = '/'
    })
}
const handleCancel = ()=>{
    console.log('取消')
    confirmHandler = undefined
    visible.value = false
}
const open = (onConfirmed?: () => void)=>{
    confirmHandler = onConfirmed
    visible.value = true
}
onMounted(()=>{
})
defineExpose({
    open
})
</script>

<style lang="scss" scoped>
.desktop-logout-content{
    width: 400px;
    height: 202px;
    padding: 24px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    .logout-content-title {
        font-size: 16px;
        font-weight: bold;
        color: #262626;
        margin-top: 16px;
    }
    .logout-content-sub_title {
        font-size: 14px;
        color: #262626;
        margin-top: 16px;
    }
    .logout-content-button {
        margin-top: 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        gap: 10px;
        .logout-content-button-item_cancel {
            width: 50%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border: 1px solid #2590E1;
            border-radius: 4px;
            cursor: pointer;
            .logout-content-button-item_cancel_text {
                font-size: 14px;
                color: #2590E1;
            }
            &:hover {
                opacity: 0.7;
            }
        }
        .logout-content-button-item_confirm {
            width: 50%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #2590E1;
            border-radius: 4px;
            cursor: pointer;
            .logout-content-button-item_confirm_text {
                font-size: 14px;
                color: #fff;
            }
            &:hover {
                opacity: 0.7;
            }
        }
    }
}
</style>
